lmApp
  .config(['$routeProvider', '$locationProvider', function ($routeProvider, $locationProvider) {

    $routeProvider
      .when('/', {
        templateUrl: 'welcome/welcome.tpl.html',
        controller: 'WelcomeController'
      })
      .when('/register', {
        templateUrl: 'register/register.tpl.html',
        controller: 'RegisterController'
      })
      .when('/greetings', {
        templateUrl: 'greetings/greetings.tpl.html',
        controller: 'GreetingsController'
      })
      .when('/greetings/:activationCode', {
        templateUrl: 'greetings/greetings.tpl.html',
        controller: 'GreetingsController'
      })
      .when('/support', {
        redirectTo: '/content/vod'
      })
      .when('/support/contacts_help', {
        templateUrl: 'contacts/contacts.tpl.html',
        controller: 'ContactsController'
      })
      .when('/profile', {
        templateUrl: 'profile/profile.tpl.html',
        controller: 'ProfileController'
      })
      .when('/content', {
        redirectTo: '/content/vod'
      })
      .when('/content/vod', {
        templateUrl: 'vod2/vod.tpl.html',
        controller: 'VodController',
        reloadOnSearch: false
      })
      .when('/content/live', {
        templateUrl: 'live/live.tpl.html',
        controller: 'LiveController',
        reloadOnSearch: false
      })
      .when('/content/catchup', {
        templateUrl: 'catchup/catchup.tpl.html',
        controller: 'CatchupController',
        reloadOnSearch: false
      })
      .when('/content/import', {
        templateUrl: 'import/import.tpl.html',
        controller: 'ImportController'
      })
      .when('/content/metadata', {
        templateUrl: 'meta/meta.tpl.html',
        controller: 'MetaController',
        reloadOnSearch: false
      })
      .when('/content/packages', {
        templateUrl: 'package/package.tpl.html',
        controller: 'PackageController',
        reloadOnSearch: false
      })
      .when('/subscribers', {
        redirectTo: '/subscribers/list'
      })
      .when('/subscribers/list', {
        templateUrl: 'subscribers/subscribers.tpl.html',
        controller: 'SubscribersController',
        reloadOnSearch: false
      })
      .when('/subscribers/groups', {
        templateUrl: 'group/group.tpl.html',
        controller: 'GroupController',
        reloadOnSearch: false
      })
      .when('/subscribers/favorites', {
        templateUrl: 'favorites/favorites.tpl.html',
        controller: 'FavoritesController',
        reloadOnSearch: false
      })
      .when('/subscribers/sessions', {
        templateUrl: 'sessions/sessions.tpl.html',
        controller: 'SessionsController',
        reloadOnSearch: false
      })
      .when('/restrictions', {
        redirectTo: '/restrictions/geoip-rules'
      })
      .when('/restrictions/geoip-rules', {
        templateUrl: 'geoip/geoip-rules.tpl.html',
        controller: 'GeoIPRulesController',
        reloadOnSearch: false
      })
      .when('/npvr', {
        redirectTo: '/npvr/records'
      })
      .when('/npvr/records', {
        templateUrl: 'npvr/records.tpl.html',
        controller: 'NPVRController',
        reloadOnSearch: false
      })
      .when('/relations/packages', {
        templateUrl: 'package/package.tpl.html',
        controller: 'PackageController',
        reloadOnSearch: false
      })
      .when('/statistic', {
        redirectTo: '/statistic/overview'
      })
      .when('/statistic/overview', {
        templateUrl: 'statistics/overview.tpl.html',
        controller: 'OverviewController'
      })
      .when('/statistic/reports', {
        templateUrl: 'statistics/reports.tpl.html',
        controller: 'ReportsController'
      })
      .when('/billing/stripeconnect', {
        templateUrl: 'billing/stripe.tpl.html',
        controller: 'StripeController'
      })
      .when('/billing/stripe', {
        templateUrl: 'billing/stripe.tpl.html',
        controller: 'StripeController'
      })
      .when('/billing/paypal-express', {
        templateUrl: 'billing/paypal-express.tpl.html',
        controller: 'PaypalExpressController'
      })
      .when('/billing/paypal-payflow', {
        templateUrl: 'billing/paypal-payflow.tpl.html',
        controller: 'PaypalPayflowController'
      })
      .when('/billing/invoice', {
        templateUrl: 'billing/invoice.tpl.html',
        controller: 'InvoiceController'
      })
      .when('/billing/offers', {
        templateUrl: 'offer/offer.tpl.html',
        controller: 'OfferController',
        reloadOnSearch: false
      })
      .when('/billing/plans', {
        templateUrl: 'plan/plan.tpl.html',
        controller: 'PlanController',
        reloadOnSearch: false
      })
      .when('/showcases', {
        templateUrl: 'showcase/showcase.tpl.html',
        controller: 'ShowcaseController'
      })
      .when('/epg', {
        redirectTo: '/epg/channels'
      })
      .when('/epg/channels', {
        templateUrl: 'epg/epg.tpl.html',
        controller: 'EpgController',
        reloadOnSearch: false
      })
      .when('/epg/epg-import', {
        templateUrl: 'epg/epg-import.tpl.html',
        controller: 'EpgImportController',
        reloadOnSearch: false
      })
      .when('/epg/catchup-2-0', {
        templateUrl: 'epg/catchup-2-0.tpl.html',
        controller: 'Catchup20Controller',
        reloadOnSearch: false
      })
      .when('/infrastructure', {
        redirectTo: '/infrastructure/servers'
      })
      .when('/infrastructure/servers', {
        templateUrl: 'infrastructure/servers.tpl.html',
        controller: 'ServersController'
      })
/*      .when('/infrastructure', {
        redirectTo: '/infrastructure/cdn'
      })
      .when('/infrastructure/cdn', {
        templateUrl: 'infrastructure/cdn.tpl.html',
        controller: 'CdnController'
      })
      .when('/infrastructure/monitoring', {
        templateUrl: 'infrastructure/monitoring.tpl.html',
        controller: 'MonitoringController'
      })*/
      .when('/application', {
        templateUrl: 'application/application.tpl.html',
        controller: 'ApplicationController'
      })
      .when('/application/banners-ng', {
        templateUrl: 'application/ng/banners.tpl.html',
        controller: 'NGBannerController'
      })
      .when('/application/rails', {
        templateUrl: 'application/rails/rails.tpl.html',
        controller: 'RailsController',
        reloadOnSearch: false
      })
      .when('/application/:application', {
        templateUrl: 'application/application.tpl.html',
        controller: 'ApplicationController'
      })
      .when('/superuser', {
        redirectTo: '/superuser/operators'
      })
      .when('/superuser/operators', {
        templateUrl: 'superuser/superuser.tpl.html',
        controller: 'SuperuserController'
      })
      .when('/administration', {
        redirectTo: '/administration/permissions'
      })
      .when('/administration/instances', {
        templateUrl: 'administration/instances.tpl.html',
        controller: 'InstanceController',
        reloadOnSearch: false
      })
      .when('/administration/permissions', {
        templateUrl: 'administration/permissions.tpl.html',
        controller: 'PermissionsController'
      })
      .when('/print/permissions', {
        templateUrl: 'administration/permissions.tpl.html',
        controller: 'PermissionsController'
      })
      .when('/dashboard', {
        templateUrl: 'owner-auth/owner-auth.tpl.html',
        controller: 'OwnerAuthController'
      })
      .otherwise({ redirectTo: '/' });

    if (window.history && window.history.pushState) {
      $locationProvider.html5Mode({
        enabled: true,
        requireBase: false
      });
    }
  }]);
